import request from '@/utils/request'

/**
 * 化学品列表
 * @param {*} data 
 * @returns 
 */
export const getHXPList = (data) =>  request({
    method: 'get',
    url: `/yzdservice/api/hxp/tree`,
    data: data
})

/**
 * 新增化学品
 * @param {*} data 
 * @returns 
 */
 export const addHXP = (data) =>  request({
    method: 'post',
    url: `/yzdservice/api/hxp/add`,
    data: data
})

/**
 * 修改化学品
 * @param {*} data 
 * @returns 
 */
 export const updateHXP = (data) =>  request({
    method: 'put',
    url: `/yzdservice/api/hxp/edit`,
    data: data
})

/**
 * 获取化学品单位
 * @param {*} data 
 * @returns 
 */
 export const getHXPUnit = (data) =>  request({
    method: 'get',
    url: `/yzdservice/api/hxp/dw/list`,
    data: data
})



